/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/23/20
 *
 */
import BaseObject from "@shared/BaseObject.js";
import {FeatureIdEnum} from "@shared/Subscription/Features/FeatureIdEnum";

export default class FeatureItem extends BaseObject {

	featureId: string = null
	title: string = null
	description: string = null

	isStorageAddon(){
		return this.featureId === FeatureIdEnum.DRIVE_STORAGE
	}
}
